<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div class="search-filters">
          <div style="margin-right: 30px;">
            会议名称
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.meetingName"></a-input>
          </div>
          <div>
            会议状态
            <a-select class="inp ml10" placeholder="请选择" v-model:value="query.status">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">进行中</a-select-option>
              <a-select-option value="1">已结束</a-select-option>
            </a-select>
          </div>
          <div class="ml30">
            创建时间
            <a-range-picker class="inp ml10"
                            v-model:value="query.createDateRange"
                            format="YYYY-MM-DD"></a-range-picker>
          </div>

          <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
          <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
          <div></div>
        </div>
      </div>
      <div class="search-r">
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id"
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto', }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'reviewResult'">
          {{ getReviewResultView(record.reviewResult) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button v-if="record.reviewResult === 1" type="link" @click="detail(record)" style="padding: 0">查看详情</a-button>
          </span>
        </template>
      </template>
    </a-table>

    <a-modal
      title="会议详情"
      v-model:open="detailVisible"
      @cancel="handleDetailCancel"
      width="800px"
      :footer="null"
    >
      <div class="meeting-detail-content">
        <div class="meeting-info-section">
          <div class="meeting-details">
            <div class="detail-item">
              <span class="detail-label">会议名称：</span>
              <span class="detail-value">{{ detailRecord.meetingName || '-' }}</span>
            </div>
            
            <div class="detail-item">
              <span class="detail-label">会议日期：</span>
              <span class="detail-value">{{ detailRecord.meetingDate || '-' }}</span>
            </div>
            
            <div class="detail-item">
              <span class="detail-label">会议评审结果：</span>
              <span class="detail-value">{{ getReviewResultView(detailRecord.reviewResult) }}</span>
            </div>
            
            <div class="detail-item full-width" style="align-items: flex-start;">
              <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">会议纪要：</span>
              <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
                <span>{{ detailRecord.meetingSummary || '-' }}</span>
              </div>
            </div>
            
            <div class="detail-item full-width" style="align-items: flex-start;">
              <span class="detail-label" style="align-self: flex-start; margin-top: 4px;">专家组意见：</span>
              <div class="detail-value" style="align-self: flex-start; margin-top: 4px;">
                <span>{{ detailRecord.expertOpinion || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="meeting-attachment-section">
          <div class="attachment-header">
            <h4>会议附件</h4>
          </div>
          <div class="attachment-content">
            <div v-if="!detailRecord.attachments || detailRecord.attachments.length === 0" class="no-data">
              暂无附件
            </div>
            <div v-else>
              <a-list :data-source="detailRecord.attachments">
                <template #renderItem="{ item }">
                  <a-list-item>
                    <a>{{ item.name }}</a>
                  </a-list-item>
                </template>
              </a-list>
            </div>
          </div>
        </div>

        <div class="selected-applications">
          <div class="section-header">
            <h3>关联申请信息</h3>
          </div>
          <a-table :columns="detailColumns" :row-key="(record) => record.id"
                   :data-source="detailRecord.applications || []" size="middle"
                   :pagination="false" :scroll="{ y: 200 }">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'testTime'">
                {{ record.startDate }} 至 {{ record.endDate }}
              </template>
              <template v-if="column.key === 'status'">
                {{ getStatusView(record.status) }}
              </template>
            </template>
          </a-table>
          <div v-if="!detailRecord.applications || detailRecord.applications.length === 0" class="no-data">
            暂无关联申请信息
          </div>
        </div>
      </div>

      <div class="action-section">
        <div class="action-buttons">
          <a-button @click="handleDetailCancel">关闭</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { reviewMeetingPageList, deleteReviewMeetingById, overReviewMeeting } from "@/api/application/reviewMeetings"
import moment from "moment";
import useUserStore from '@/store/modules/user'
import { Modal, message } from 'ant-design-vue';
import { getStatusView } from '@/utils/applicationUtils';

const store = useUserStore();
const router = useRouter();

const columns = [
  {
    title: "申请类型",
    dataIndex: "applicationName",
    key: "applicationName",
    width: 220,
  },
  {
    title: "申请数量",
    dataIndex: "total",
    key: "total",
    width: 120,
  },
  {
    title: "会议名称",
    dataIndex: "meetingName",
    key: "meetingName",
    width: 200,
  },
  {
    title: "评审结果",
    dataIndex: "reviewResult",
    key: "reviewResult",
    width: 120,
  },
  {
    title: "会议时间",
    dataIndex: "meetingDate",
    key: "meetingDate",
    width: 180,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    width: 180,
  },
  {
    title: "操作",
    key: "action",
    width: 200,
  },
];

const detailColumns = [
  {
    title: "申请编号",
    dataIndex: "applicationNo",
    key: "applicationNo",
    width: 200,
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    width: 180,
  },
  {
    title: "申请类型",
    dataIndex: "categoryName",
    key: "categoryName",
  },
  {
    title: "车辆识别代码",
    dataIndex: "vin",
    key: "vin",
    width: 200,
  },
  {
    title: "申请有效期",
    key: "testTime",
    width: 220,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    width: 150,
  },
];

let dataSource = ref([]);
const detailVisible = ref(false);
const detailRecord = ref({});

let query = reactive({
  meetingName: null,
  status: null,
  createDateRange: null
});

const pageChange = (page, pageSize) =>{
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

const getReviewResultView = (result) => {
  const statusMap = {
    0: '未通过',
    1: '已通过'
  };
  return statusMap[result] || '未通过';
}

const search = () => {
  pagination.current = 1
  getData();
};

const reset = () => {
  query.meetingName = null;
  query.status = null;
  query.createDateRange = null;
  getData();
};

const getData = async () => {
  const queryData = { ...query };
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...queryData },
  };
  reviewMeetingPageList(data).then((res) => {
    if (res.code === 200) {
      dataSource.value = res.data.records || res.data || [];
      pagination.total = res.data.total || dataSource.value.length;
    }
  });
};

const overMeeting = (record) => {
  Modal.confirm({
    title: '确认结束会议',
    content: `确定要结束会议「${record.meetingName}」吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const response = await overReviewMeeting({ id: record.id });
        if (response.code === 200) {
          message.success('会议已结束');
          getData();
        } else {
          message.error(response.message || '操作失败');
        }
      } catch (error) {
        console.error('结束会议失败:', error);
        message.error('结束会议失败，请重试');
      }
    }
  });
}

const deleteMeeting = (id) => {
  Modal.confirm({
    title: '确认删除',
    content: '确定要删除该会议吗？',
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const response = await deleteReviewMeetingById(id);
        if (response.code === 200) {
          message.success('删除成功');
          getData();
        } else {
          message.error(response.message || '删除失败');
        }
      } catch (error) {
        console.error('删除会议失败:', error);
        message.error('删除会议失败，请重试');
      }
    }
  });
}

const detail = (row) => {
  detailRecord.value = { ...row };
  detailVisible.value = true;
};

const handleDetailCancel = () => {
  detailVisible.value = false;
};

onMounted(async () => {
  await getData();
});
</script>

<style lang="less" scoped>
.inp {
  width: 15.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    align-items: center;
  }

  .search-r {
    display: flex;
    align-items: center;
  }
}

.search-filters {
  display: flex;
  padding: 12px;
  border-radius: 4px;
  flex-wrap: wrap;
  align-items: center;
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}

.meeting-detail-content {
  max-height: 60vh;
  overflow-y: auto;
}

.meeting-info-section {
  padding: 10px 0;
}

.meeting-details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 50px;
}

.detail-item {
  display: flex;
  align-items: center;
}

.detail-item.full-width {
  min-width: 100%;
  width: 100%;
}

.detail-label {
  width: 120px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  margin-right: 10px;
}

.detail-value {
  flex: 1;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
  min-width: 150px;
}

.meeting-attachment-section {
  border-top: 1px solid #e8e8e8;
  margin-top: 16px;
  padding-top: 16px;
}

.attachment-header {
  margin-bottom: 12px;
  
  h4 {
    margin: 0;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.attachment-content {
  margin-top: 8px;
}

.selected-applications {
  border-top: 1px solid #e8e8e8;
  margin-top: 16px;
  padding-top: 16px;
}

.section-header {
  padding: 8px 0;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 12px;
  
  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

.action-section {
  padding: 16px 0 0;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  gap: 12px;
}
</style>